module.exports = __webpack_public_path__ + "img/logo.3fa9a2de.png";